import { HOME_ROUTE, LANDING_ROUTE } from "_constants";
import { authRoutes } from "./AuthRoutes";
import { homeRoutes } from "./HomeRoutes";
import { accountRoutes } from "./AccountRoutes";
import { profileRoutes } from "./ProfileRoutes";
import { settingsRoutes } from "./SettingsRoutes";
import { transactionsRoutes } from "./TransactionsRoutes";
// import { legalDocumentsRoutes } from "./LegalDocumentsRoutes";
import { tradeRoutes } from "./TradeRoutes";
import { introducingBrokerRoutes } from "./IntroducingBrokerRoutes";
import { newsRoutes } from "./NewsRoutes";
import { copyTradingRoutes } from "./CopyTradingRoutes";
import { onboardingRoutes } from "./OnboardingRoutes";

const authorizedStructure = {
  fallbackPath: LANDING_ROUTE,
  routes: [
    ...accountRoutes,
    ...profileRoutes,
    ...settingsRoutes,
    ...transactionsRoutes,
    // ...legalDocumentsRoutes,
    ...tradeRoutes,
    ...homeRoutes,
    ...introducingBrokerRoutes,
    ...newsRoutes,
    ...copyTradingRoutes,
  ],
};
const unAuthorizedStructure = {
  fallbackPath: HOME_ROUTE,
  routes: [...authRoutes],
};
const anonymousStructure = {
  fallbackPath: "",
  routes: [],
};
const alwaysStructure = { fallbackPath: "", routes: [...onboardingRoutes] };

export {
  authorizedStructure,
  unAuthorizedStructure,
  anonymousStructure,
  alwaysStructure,
};
